import React from 'react';
import Styles from './assets/styles.scss';
import { ChatInput } from './components/ChatInput';
import { ChatMessages } from './components/ChatMessages';
import { ChatNotifications } from './components/ChatNotifications';
import { ChatSection } from './components/ChatSection';
import { PredefinedPrompts } from './components/PredefinedPrompts';
import { IBCChatProps } from './entities/IBCChatProps';

const BCChat: React.FC<IBCChatProps> = props => {
	return (
		<div className={[Styles.container, props.className || ''].join(' ')}>
			<ChatSection>
				{!props.messages.length && (
					<PredefinedPrompts
						items={props.predefinedPrompts}
						onPromptSent={props.onPromptSent}
					/>
				)}
				<ChatMessages
					messages={props.messages}
					onResponseSent={props.onResponseSent}
				/>
			</ChatSection>
			<ChatInput
				placeHolder={props.placeHolder}
				loading={props.loading}
				disabled={props.disabled}
				onPromptSent={props.onPromptSent}
			>
				<ChatNotifications notifications={props.notifications} />
			</ChatInput>
		</div>
	);
};

export { BCChat };
